export const SERVICE_TYPE = 1;
export const PROBLEM_TYPE = 2;
export const STATION_TYPE = 3;
export const SYNONYM_TYPE = 4;
export const MASTER_TYPE = 5;

export const stationUrlFormat = ({locale, type, city, slug, paramsLink}) => `/${locale}/${type}/c-${city}/${slug}${paramsLink ? `?${paramsLink}` : ''}`;